import { Badge, BadgeProps } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { CameraSource } from '@/types/camera'

const messageMap = {
  [CameraSource.Milestone]: {
    id: 'cameras.source.milestone',
    color: 'blue'
  },
  [CameraSource.Visionplatform]: null
}

type CameraSourceBadgeProps = {
  source: CameraSource
  size?: BadgeProps['size']
}

export const CameraSourceBadge = ({
  source,
  size = 'xs'
}: CameraSourceBadgeProps) => {
  const settings = messageMap[source]

  if (settings) {
    return (
      <Badge size={size} color={settings.color}>
        <FormattedMessage id={settings.id} />
      </Badge>
    )
  }

  return null
}
